import {
  AuthenticationService,
  MutationHandlingServiceV2,
  QueryHandlingService,
} from '@akebono/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, pluck, shareReplay } from 'rxjs/operators';
import {
  GuidanceRequestCreateGQL,
  HasActiveGuidanceRequestGQL,
} from 'src/app/modules/graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
})
export class ForbiddenComponent implements OnInit {
  hasLotsPermission$ = of(false);
  hasActiveGuidanceRequest$ = of(false);
  uuid$: Observable<string | null>;

  loading$ = of(false);
  navigating = false;
  creatingRequest$ = of(false);

  constructor(
    private router: Router,
    private qhs: QueryHandlingService,
    private mhs: MutationHandlingServiceV2,
    private authService: AuthenticationService,
    private guidanceRequestCreateGQL: GuidanceRequestCreateGQL,
    private hasActiveGuidanceRequestGQL: HasActiveGuidanceRequestGQL,
  ) {}

  ngOnInit(): void {
    const queryRef = this.qhs.watch(this.hasActiveGuidanceRequestGQL);

    this.loading$ = queryRef.loading.pipe(shareReplay(1));
    this.hasActiveGuidanceRequest$ = queryRef.data.pipe(
      map((data) => data.currentUser?.hasActiveGuidanceRequest || false),
      shareReplay(1),
    );

    this.hasLotsPermission$ = from(this.authService.checkPermissions(['cars.lots']));
    this.uuid$ = queryRef.data.pipe(
      map((data) => {
        const currentUserId = data.currentUser?.id;

        if (currentUserId) {
          return this.convertIdToUUID(currentUserId);
        } else {
          return null;
        }
      }),
    );
  }

  createGuidanceRequest(): void {
    this.creatingRequest$ = this.mhs.mutate(
      this.guidanceRequestCreateGQL,
      {
        input: {},
      },
      {
        refetch: true,
        successTranslationKey: 'GUIDANCE_REQUEST_CREATED',
      },
    ).loading;
  }

  convertIdToUUID(id: string): string {
    const uuid: string = Number(id).toString(32).toUpperCase();
    return uuid.length < 4 ? ('000' + uuid).slice(-4) : uuid;
  }

  navigateToMain() {
    if (!this.navigating) {
      this.navigating = true;
      const t = setTimeout(() => {
        this.router.navigateByUrl('/');
        clearTimeout(t);
      }, 3000);
    }
  }

  singOut(): void {
    this.authService.signOut();
    this.router.navigateByUrl('/sign-in');
  }
}
